import React from 'react';
import {
  Box,
  Flex,
  Heading,
  Text,
  HStack,
  Button,
  Select,
  Icon,
} from '@chakra-ui/react';
import { FiRefreshCw } from 'react-icons/fi';

/**
 * DashboardHeader - Component for the dashboard header with title and controls
 * 
 * @param {Object} props - Component props
 * @param {string} props.timeFrame - Current selected time frame
 * @param {Function} props.onTimeFrameChange - Function to handle time frame change
 * @param {Function} props.onRefresh - Function to handle refresh button click
 */
const DashboardHeader = ({ timeFrame, onTimeFrameChange, onRefresh }) => {
  return (
    <Flex justify="space-between" align="center" mb={6}>
      <Box>
        <Heading size="lg">Dashboard Master</Heading>
        <Text color="gray.500">Visão geral completa do sistema</Text>
      </Box>
      <HStack>
        <Text mr={2}>Período:</Text>
        <Select value={timeFrame} onChange={onTimeFrameChange} w="150px">
          <option value="day">Hoje</option>
          <option value="week">Esta Semana</option>
          <option value="month">Este Mês</option>
          <option value="quarter">Este Trimestre</option>
          <option value="year">Este Ano</option>
        </Select>
        <Button 
          leftIcon={<Icon as={FiRefreshCw} />} 
          colorScheme="yellow" 
          variant="outline"
          onClick={onRefresh}
        >
          Atualizar
        </Button>
      </HStack>
    </Flex>
  );
};

export default DashboardHeader;